
  import {defineComponent, onMounted, reactive, toRefs} from 'vue'
  import headerText from "@/layout/header/headerText";
  import useStore from "@/store";
  import {useRouter} from "vue-router";

  export default defineComponent({
    name: 'index',
    setup(props, ctx) {
      const store = useStore()
      const router = useRouter()
      const dataMap = reactive({
        btnName: '更多',
        btnName2: '立即获取',
        solutionsActive: '3_1',
        solutionsText: headerText.menus[2]
      })
      const gotoDetail = (btn)=>{
        if(btn&&btn.path){
          router.push({
            path:btn.path
          })
        }
      }
      return {
        ...toRefs(dataMap),
        gotoDetail
      }
    }
  })
